<template>
  <div class="stayStudent" style="background-color: #fff;min-height: 100vh;">
    <div class="stayStudent_top">
      <div class="top_search">
        <!-- 搜索姓名 -->
        <div class="filter-input">
          <div class="search-icon">
            <img src="./search-icon.png" />
          </div>
          <input placeholder="请输入学生姓名" v-model="userName" />
        </div>
        <div class="filter_record">
          <div class="record_leave" @click="handleLeaveRecord">
            <img src="./leave_.png" alt="">
            <span>请假记录</span>
          </div>
          <div class="record_line"> 

          </div>
          <div class="record_stay" @click="handleStayRecord">
            <img src="./stay.png" alt="">
            <span>留宿记录</span>
          </div>
        </div>
      </div>
      <!-- 班级列表及日期选择部分 -->
      <div class="classlist_date">

        <!-- 选择班级 -->
        <div class="classlist">
          <van-tabs v-model="active" background="transparent" color="#fff" @change="selectChange" :swipe-threshold="1">
            <van-tab name="1" title-class="class_tab" key="1" title="全部"></van-tab>
            <van-tab :name="item.id" title-class="class_tab" v-for="item in columns" :key="item.id"
              :title="item.label"></van-tab>
          </van-tabs>
        </div>
        <div class="date">
          <filterDateStay v-model="date"></filterDateStay>
        </div>
      </div>
      <div class="top_info">
        <div class="info_con">

          <!-- 住宿生  -->
          <div class="info_con_item info_con_item_line" @click="handleChangeDormStatus('')">
            <div class="con_item_info">
              <div :class="nowSelectDormStatus === '' ? 'con_item_title con_item_title_active' : 'con_item_title'">住宿生
              </div>
              <div :class="nowSelectDormStatus === '' ? 'con_item_num con_item_num_active' : 'con_item_num'">{{
            dormUserNum }}</div>
            </div>

          </div>

          <!-- 今日住宿 -->
          <!-- <div class="info_con_item info_con_item_line" @click="handleChangeDormStatus(0)">
            <div class="con_item_info">
              <div :class="nowSelectDormStatus === 0 ? 'con_item_title con_item_title_active' : 'con_item_title'">今日住宿
              </div>
              <div :class="nowSelectDormStatus === 0 ? 'con_item_num con_item_num_active' : 'con_item_num'">{{
            atDormUserNum }}</div>
            </div>

          </div> -->

          <!-- 请假在寝 -->
          <div class="info_con_item info_con_item_line" @click="handleChangeDormStatus(10)">
            <div class="con_item_info">
              <div :class="nowSelectDormStatus === 10 ? 'con_item_title con_item_title_active' : 'con_item_title'">请假在寝
              </div>
              <div :class="nowSelectDormStatus === 10 ? 'con_item_num con_item_num_active' : 'con_item_num'">{{
            leaveAtDormNum }}</div>
            </div>


          </div>

          <!-- 请假离校 -->
          <div class="info_con_item info_con_item_line" @click="handleChangeDormStatus(11)">
            <div class="con_item_info">
              <div :class="nowSelectDormStatus === 11 ? 'con_item_title con_item_title_active' : 'con_item_title'">请假离校
              </div>
              <div :class="nowSelectDormStatus === 11 ? 'con_item_num con_item_num_active' : 'con_item_num'">{{
            leaveOutSchoolNum }}</div>

            </div>

          </div>

          <!-- 留宿 -->
          <div class="info_con_item" @click="handleChangeDormStatus(13)">
            <div class="con_item_info">
              <div :class="nowSelectDormStatus === 13 ? 'con_item_title con_item_title_active' : 'con_item_title'">假期留宿
              </div>
              <div :class="nowSelectDormStatus === 13 ? 'con_item_num con_item_num_active' : 'con_item_num'">{{
            accommodateNum }}</div>
            </div>

          </div>
        </div>

      </div>
    </div>

    <div class="stayStudent_bottom">

      <div class="bottom_con">

        <template v-for="item in classInfoStudentInfo">
          <div class="stayStudent_bottom_item" v-if="item.users.length > 0" :key="item.id">
            <div class="bottom_item_classname">
              <span>{{ item.label }}</span>
              <div class="classname-content_left" v-if="item.users.length > 0">
                <van-checkbox v-if="isBatchProcess" class="content_left_check" shape="square" @click="handleRoom(item)"
                  icon-size="14px" :value="roomIsSelected(item)">全选</van-checkbox>
              </div>
            </div>


            <div class="bottom_item_stulist">
              <div class="stulist_item" @click="handleGoPersonDetail(user)" v-for="user in item.users">
                <!-- 批量处理选择 -->
                <div class="members_radio">
                  <van-checkbox class="custom-checkbox_2" v-if="isBatchProcess" :value="bedIsSelected(user)"
                    icon-size="14px" />
                </div>

                <!-- 请假或留宿标签 -->
                <div class="item_leave" v-if="user.dormType == 0">假</div>
                <div class="item_stay" v-if="user.dormType == 1">宿</div>
                {{ user.userName }}
              </div>

            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="handle_popup" :style="{ bottom: buttonBottom + 'px', right: buttonRight + 'px' }"
      @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">


      <img class="handle_popup_img" src="./chuli_popup.png" @click="() => {
            this.isBatchProcess = !this.isBatchProcess
            this.nowSelectPersonList = []
          }" />

      <div @click="() => {
            this.isBatchProcess = !this.isBatchProcess
            this.nowSelectPersonList = []
          }" class="handle_popup_text">
        {{ isBatchProcess ? '取消批量' : '批量处理' }}
      </div>
      <!-- 功能 -->
      <div :class="isBatchProcess ? 'expand_div expand_open ' : 'expand_div expand_close'">

        <div @click="handleStayProcess"
          :class="isBatchProcess ? 'expand_div_item expand_div_item_show' : 'expand_div_item expand_div_item_hidden'">
          <img class="expand_div_item_img" src="./batch_stay.png" />
          <span class="expand_div_item_text">留宿处理</span>
        </div>

        <div @click="handleBatchSign"
          :class="isBatchProcess ? 'expand_div_item expand_div_item_show' : 'expand_div_item expand_div_item_hidden'">
          <img class="expand_div_item_img" src="./batch_ leave.png" />
          <span class="expand_div_item_text">请假处理</span>
        </div>
      </div>
    </div>


    <!-- 请假批量处理 -->
    <batchLeavePop :leaveMatters="leaveType" :batchLeaveDateInfo="batchLeaveDateInfo" ref="batchLeavePopRef"
      @openLeaveDate="openLeaveDate" @openPicker="showPicker = true" @confirm="search('rember')"></batchLeavePop>
    <!-- 留宿批量处理 -->
    <batchPutUpPop :selectFloor="nowSelectFloor" :leaveMatters="leaveType" :batchLeaveDateInfo="batchLeaveDateInfo"
      @openLeaveDate="openLeaveDate" @openPicker="showPicker = true" ref="batchPutUpPopRef" @confirm="search('rember')">
    </batchPutUpPop>
    <!-- 请假事项选择 -->
    <van-popup v-model="showPicker" get-container="#app" round position="bottom">
      <van-picker title="事项" show-toolbar :columns="typeColumns" @cancel="showPicker = false"
        @confirm="handleLeaveMatter" />
    </van-popup>


    <!-- 请假时间选择 -->
    <leaveSettingPop @getLeaveDateInfo="getLeaveDateInfo" :selectFloor="nowSelectFloor"
      :personList="nowSelectPersonList" ref="leaveSettingPopRef"></leaveSettingPop>





  </div>
</template>

<script>

import moment from 'moment';
import filterDateStay from './filterDateStay';
import batchPutUpPop from './batchPutUpPop.vue';
// 请假时间设置
import leaveSettingPop from './leaveSettingPop.vue';
// 请假批量处理
import batchLeavePop from './batchLeavePop.vue';
export default {
  components: {
    filterDateStay, batchPutUpPop, leaveSettingPop, batchLeavePop
  },
  name: 'stay-change',
  data() {
    return {
      userName: null,
      // 拖拽参数
      isDragging: false,
      // 班主任管理班级列表
      columns: [],
      // 管理班级及学生数据
      classInfoStudentInfo: [],

      // 住宿生人数
      dormUserNum: 0,
      // 今日住宿人数
      atDormUserNum: 0,
      // 请假在寝数量
      leaveAtDormNum: 0,
      // 请假离校人数
      leaveOutSchoolNum: 0,
      // 留宿人数
      accommodateNum: 0,

      // 当前选中的宿舍状态
      nowSelectDormStatus: '',

      active: '1',
      date: moment(new Date()).format('YYYY-MM-DD'),

      // 当前选中人员
      nowSelectPersonList: [],

      // 拖拽相关参数
      startX: 0,
      startY: 0,
      buttonBottom: 16,
      buttonRight: 9,
      baseBottom: 16,
      isBatchProcess: false,
      nowSelectPersonList: [],

      // 批量请假
      leaveType: '事假',
      typeColumns: ['事假', '病假', '其他'],
      nowSelectFloor: '',
      // 批量请假时间选择数据
      batchLeaveDateInfo: {},
      showPicker: false,

      selectTimeType: 1,
    };
  },
  created() {
    // 获取当前老师管理的班级
    this.getClassListByTeacherId()

  },
  mounted() {

  },
  computed: {

  },
  watch: {

    // 日期改变刷新数据 
    date() {
      this.getClassStudentDorm()
    },
    userName() {
      this.getClassStudentDorm()

    }
  },
  methods: {
    getLeaveDateInfo(data) {
      this.batchLeaveDateInfo = data;
    },
    openLeaveDate(type) {
      this.batchLeaveDateInfo.type = type
      this.$refs.leaveSettingPopRef.open(this.batchLeaveDateInfo);
    },
    handleLeaveMatter(value) {
      console.log(value)
      this.showPicker = false
      this.leaveType = value
    },


    // 获取班主任管理的班级列表
    async getClassListByTeacherId() {
      const { data, code } = await this.$https.getClassListByTeacherId({
        teacherId: this.$store.state.userId
      });
      if (code !== 200) {
        return false;
      }
      let arr = [];
      const fn = (data) => {
        data.forEach(item => {
          if (item.children) {
            fn(item.children)
          } else {
            arr.push(item)
          }
        })
      }
      // 获取所有班级
      fn(data)
      this.columns = arr;
      console.log('班级列表', arr)
      this.getClassStudentDorm()
    },

    // 获取班级中宿舍所有人员
    getClassStudentDorm() {
      // 清空选中人员
      this.nowSelectPersonList = []
      const loading = this.$toast.loading({
        duration: 0,
        message: '加载中',
        forbidClick: true,
        getContainer: '#app'
      });
      this.$https.getDormUserDateByTeacher({
        dormStatus: this.nowSelectDormStatus,
        findDate: this.date,
        orgIds: this.active == 1 ? this.columns.map(item => item.id) : null,
        organId: this.active == 1 ? null : this.active,
        schoolId: this.$store.state.schoolId,
        userName: this.userName
      }).then(res => {


        if (res.code == 200) {
          loading.clear();
          this.classInfoStudentInfo = res.data.dormUserTree
          // 人数赋值
          this.dormUserNum = res.data.dormUserNum //住宿生
          this.atDormUserNum = res.data.atDormUserNum //今日住宿
          this.leaveAtDormNum = res.data.leaveAtDormNum //请假在寝
          this.leaveOutSchoolNum = res.data.leaveOutSchoolNum //请假离校
          this.accommodateNum = res.data.accommodateNum //留宿
        } else {
          loading.clear();
          this.$toast(res.msg);
        }
      })

    },

    // 选中标签改变时触发
    selectChange() {
      this.getClassStudentDorm()
    },



    // 点击请假记录
    handleLeaveRecord() {
      // 跳转到请假记录
      this.$router.push({ path: '/leaveRecord' })
    },
    // 点击留宿记录 
    handleStayRecord() {
      this.$router.push({ path: '/stayRecord' })
    },


    // 点击人员跳转人员详情
    handleGoPersonDetail(data) {
      if (!this.isBatchProcess) {
        this.$router.push({
          path: '/personDetail', query: {
            userId: data.userId,
            findDate: this.date
          }
        })
      } else {
        // 选中当前人员
        console.log('选中当前人员')
        // 判断选中的人员中是否有当前人员
        if (this.nowSelectPersonList.find(item => item.userId == data.userId)) {
          this.nowSelectPersonList = this.nowSelectPersonList.filter(item => item.userId != data.userId)
        } else {
          this.nowSelectPersonList.push(data)
        }
      }
    },
    bedIsSelected(data) {
      if (this.nowSelectPersonList.find(item => item.userId == data.userId)) {
        return true
      } else {
        return false
      }
    },

    // 判断班级是否全部选中
    roomIsSelected(data) {
      let arr = data.users.filter(x => x.userId != null)
      let bol = this.isContained(this.nowSelectPersonList, arr)
      return bol
    },


    isContained(array1, array2) {
      return array2.every(item2 =>
        array1.some(item1 => (
          item1.userId === item2.userId
        ))
      );
    },
    handleRoom(data) {
      let arr = data.users.filter(x => x.userId != null)
      if (this.isContained(this.nowSelectPersonList, arr)) {
        // 取消选中
        this.nowSelectPersonList = this.nowSelectPersonList.filter(item => !arr.find(x => x.userId == item.userId))
      } else {
        this.nowSelectPersonList = this.nowSelectPersonList.concat(arr)
        this.nowSelectPersonList = this.nowSelectPersonList.filter((item, index, self) =>
          index === self.findIndex((t) => (
            t.userId === item.userId && item.dormOrganId === item.dormOrganId
          ))
        );
      }
    },

    search() {
      // let loading = null;
      // loading = this.$toast.loading({
      //   duration: 0,
      //   message: '加载中',
      //   forbidClick: true,
      //   getContainer: '#app'
      // });
      this.getClassStudentDorm()

    },
    // 输入姓名搜索 
    searchChange() {
      console.log('123')
    },

    handleBatchSign() {
      if (this.nowSelectPersonList.length) {
        console.log('this.date',this.date)
        // 设置选中时间默认值
        this.batchLeaveDateInfo = {
          startDate: moment(this.date,'YYYY-MM-DD').format('YYYY年MM月DD日'),
          startTime: moment().format('HH:mm'),
          startDateType: 2,
          type: this.selectTimeType
        }

        this.$refs.batchLeavePopRef.open({
          findDate: this.date,
          nowSelectPersonList: this.nowSelectPersonList,
          dormOrganId: this.nowSelectFloor
        });

      } else {
        this.$toast({ getContainer: '#app', message: '请选择人员' });
        return
      }
    },


    // 点击批量请假处理
    handleStayProcess(e) {
      if (this.nowSelectPersonList.length) {
        console.log('this.nowSelectPersonList', this.nowSelectPersonList)
        // if (this.nowSelectPersonList.some(item => item.attendanceType != 1 && item.attendanceType != 2)) {
        //   this.$toast({ getContainer: '#app', message: '宿舍考勤人员不能进行留宿！' });
        // } else {
          this.batchLeaveDateInfo = {
            startDate: moment(this.date,'YYYY-MM-DD').format('YYYY年MM月DD日'),
            startTime: moment().format('HH:mm'),
            startDateType: 2,
            type: this.selectTimeType
          }

          this.$refs.batchPutUpPopRef.open({
            findDate: this.date,
            nowSelectPersonList: this.nowSelectPersonList,
          });
        // }
      } else {
        this.$toast({ getContainer: '#app', message: '请选择人员' });
        return
      }
    },


    // 点击宿舍状态
    handleChangeDormStatus(type) {
      console.log('type', type)
      this.nowSelectDormStatus = type
      this.getClassStudentDorm()
    },













    // 拖拽开始
    handleTouchStart(e) {
      e.stopPropagation()
      this.isDragging = true;
      const touch = e.touches[0];
      this.startX = touch.clientX;
      this.startY = touch.clientY;
    },

    // 拖拽结束后
    handleTouchEnd(e) {
      e.stopPropagation()
      this.isDragging = false
      this.baseBottom = this.buttonBottom
    },
    // 拖拽过程中w
    handleTouchMove(e) {
      e.preventDefault(); // 阻止默认的滚动行为
      if (!this.isDragging) return;
      const touch = e.touches[0];
      this.buttonBottom = Math.max(10, this.baseBottom - (touch.clientY - this.startY))
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes expandopen {
  from {
    width: 0;
  }

  to {
    // width: 17.5586rem;
    width: 15.0265rem;
  }
}

@keyframes expandclose {
  from {
    // width: 17.5586rem;
    width: 15.0265rem;
  }

  to {
    width: 0;
  }
}

@keyframes itemShow {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.stayStudent {
  display: flex;
  flex-direction: column;

  .stayStudent_top {
    background: url(./staychange_topbg.png);
    background-size: 100% 100%;

    .top_search {
      padding: .601rem .7212rem;
      display: flex;
      align-items: center;

      // 搜索姓名
      .filter-input {
        width: 100%;
        display: flex;
        flex: 1;
        border-radius: 0.9375rem;
        background-color: #F6F9FC;
        // opacity: 0.3;
        overflow: hidden;
        align-items: center;
        padding-right: 1rem;

        .search-icon {
          text-align: center;
          width: 2.125rem;
          flex-shrink: 0;
          padding-top: 0.2rem;
          padding-left: 0.2rem;

          img {
            height: 0.9rem;
          }
        }

        input {
          width: calc(100% - 2.2125rem);
          height: 1.875rem;
          border: 0;
          outline: 0;
          flex: 1;
          padding: 0.4375rem 0;
          font-size: 0.75rem;
          color: #333;
          background: transparent;

          &::placeholder {
            color: #999;
          }
        }
      }

      .filter_record {
        margin-left: .9014rem;
        display: flex;
        align-items: center;

        .record_leave {
          cursor: pointer;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: .7212rem;
          color: #FFFFFF;
          line-height: .9615rem;
          text-align: left;
          display: flex;
          align-items: center;
          font-style: normal;

          img {
            width: .7212rem;
            height: .7212rem;
            margin-right: .2404rem;
          }

        }

        .record_line {
          padding: 0 .7212rem;
          position: relative;

          &::before {
            content: '';
            position: absolute;
            left: 50%;
            top: 50%;
            width: 1px;
            transform: translate(-50%, -50%);
            height: .7212rem;
            background-color: #fff;
          }

        }

        .record_stay {
          cursor: pointer;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: .7212rem;
          color: #FFFFFF;
          line-height: .9615rem;
          text-align: left;
          font-style: normal;
          display: flex;
          align-items: center;

          img {
            width: .7212rem;
            height: .7212rem;
            margin-right: .2404rem;
          }
        }
      }
    }

    .classlist_date {
      height: 1.6226rem;
      margin: 0 .7212rem;
      display: flex;

      .classlist {
        flex: 1;
        max-width: 75%;
        position: relative;
        padding-right: .7212rem;

        ::v-deep .van-tabs .van-tabs__wrap .van-tabs__nav .van-tabs__line {
          width: 1.2019rem;
          left: -0.601rem;
        }

        ::v-deep .van-tabs--line .van-tabs__wrap {
          height: 1.6226rem;
          color: #fff;
          line-height: 1.6226rem;
        }

        ::v-deep .van-tabs__nav {
          padding-left: 0;
          padding-right: 0;
        }

        ::v-deep .van-tabs__nav .class_tab {
          padding: 0 1.2019rem 0 0;
        }

        ::v-deep .van-tabs__nav .class_tab .van-tab__text {
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: .8413rem;
          color: #FFFFFF;
          text-align: left;
          font-style: normal;
        }

        &::before {
          content: '';
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: .0601rem;
          height: .7212rem;
          background-color: #fff;
          opacity: .3;
        }

        &::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          top: 0;
          width: .7212rem;
          // background-color: pink;
          pointer-events: none;
          background: linear-gradient(-90deg, transparent, #286FFE);
        }
      }

      .date {
        width: 25%;
        display: flex;
        align-items: center;
      }
    }

    .top_info {
      padding: .7212rem;
      background: linear-gradient(180deg, transparent 0%, #FFFFFF 100%);

      .info_con {
        height: 3.9063rem;
        background: #FFFFFF;
        box-shadow: 0px 0px .601rem .0601rem rgba(0, 0, 0, 0.08);
        border-radius: .3606rem;
        display: flex;
        align-items: center;

        .info_con_item {
          position: relative;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;

          .con_item_info {

            display: inline-block;
            flex-direction: column;
            align-items: center;

            .con_item_title {
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              font-size: .7212rem;
              color: #333333;
              line-height: 0px;
              text-align: left;
              line-height: .9615rem;
              font-style: normal;
              margin-bottom: .2404rem;
            }

            // 选中状态
            .con_item_title_active {
              color: #3775FF;
              ;
            }



            .con_item_num {
              font-family: 'DIN Condensed', sans-serif;
              font-weight: normal;
              font-size: 1.3221rem;
              color: #333333;
              line-height: 1.6226rem;
              text-align: left;
              font-style: normal;
              text-transform: none;
              -webkit-text-stroke: 0px #333333;
            }

            // 选中状态
            .con_item_num_active {
              color: #3775FF;
            }

          }
        }

        .info_con_item_line {
          &::before {
            content: '';
            height: 1.6226rem;
            width: .0601rem;
            position: absolute;
            right: 0;
            top: 50%;
            background-color: #E8E8E8;
            transform: translateY(-50%);
          }
        }
      }
    }
  }

  .stayStudent_bottom {
    flex: 1;
    overflow-y: auto;
    position: relative;
    margin-top: .4808rem;


    .bottom_con {
      position: absolute;
      top: 0;
      left: .7212rem;
      right: .7212rem;
      padding-bottom: 1.2019rem;
      display: flex;
      flex-direction: column;


      .stayStudent_bottom_item {
        margin-bottom: 1.2019rem;

        .bottom_item_classname {
          position: relative;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: .9615rem;
          color: #333333;
          line-height: 1.262rem;
          text-align: left;
          font-style: normal;
          text-transform: none;
          padding: 0 0 0 .5409rem;
          margin-bottom: .5409rem;
          display: flex;
          justify-content: space-between;

          &::before {
            content: '';
            width: .1803rem;
            height: .7813rem;
            position: absolute;
            left: 0;
            top: 50%;
            border-radius: .601rem;
            background: #3775FF;
            transform: translateY(-50%)
          }

          .classname-content_left {
            display: flex;
            align-items: center;

            .content_left_check {

              ::v-deep.van-checkbox__icon {
                .van-icon {
                  border-radius: .1203rem;
                  border: .0601rem solid #E8E8E8;
                }

              }

              ::v-deep.van-checkbox__label {
                font-family: Microsoft YaHei, Microsoft YaHei;
                margin-left: .3606rem;
                font-weight: 400;
                font-size: .8413rem;
                color: #333333;
                line-height: 1.1418rem;
                text-align: left;
                font-style: normal;
                text-transform: none;
              }
            }


          }
        }

        .bottom_item_stulist {
          display: flex;
          flex-wrap: wrap;

          .stulist_item {
            height: 2.2837rem;
            width: 23%;
            margin-top: .601rem;
            text-align: center;
            line-height: 2.2837rem;
            background: #F6F9FC;
            border-radius: .2404rem;
            margin-right: 2.6%;
            position: relative;

            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: .8413rem;
            color: #333333;
            text-align: center;
            font-style: normal;
            // 文字省略
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            .members_radio {
              position: absolute;
              top: .1804rem;
              left: .1804rem;

              .custom-checkbox_1 {
                ::v-deep .van-icon {
                  background-color: #fff;
                }

                ::v-deep .van-checkbox__icon--checked .van-icon {
                  color: #1989fa;
                  background-color: #fff;
                  border-color: #fff;
                }
              }

              .custom-checkbox_2 {

                ::v-deep .van-checkbox__icon--checked .van-icon {
                  color: #fff;
                  background-color: #1989fa;
                  border-color: #1989fa;
                }
              }
            }

            // 请假标签
            .item_leave {
              position: absolute;
              right: 0;
              top: 0;
              width: 1.3221rem;
              height: .8413rem;
              border-radius: 0px .2404rem 0px .4808rem;
              background-color: #F1C229;
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              font-size: .601rem;
              color: #FFFFFF;
              line-height: .8413rem;
              text-align: center;
              font-style: normal;
            }

            // 留宿标签
            .item_stay {
              position: absolute;
              right: 0;
              top: 0;
              width: 1.3221rem;
              height: .8413rem;
              border-radius: 0px .2404rem 0px .4808rem;
              background-color: #F29225;
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              font-size: .601rem;
              color: #FFFFFF;
              line-height: .8413rem;
              text-align: center;
              font-style: normal;
            }


          }

          .stulist_item:nth-child(4n) {
            margin-right: 0;
          }
        }
      }
    }
  }

  .handle_popup {
    position: fixed;
    z-index: 999;
    // bottom: 1.6837rem;

    // right: .9385rem;
    right: 9px;
    bottom: 16px;




    height: 4.8707rem;
    width: 7.7132rem;

    .handle_popup_img {
      height: 100%;
      position: absolute;
      z-index: 1;
      right: 0;
    }

    .handle_popup_text {
      width: 4.5701rem;
      position: absolute;
      bottom: 0;
      right: 0;
      z-index: 2;
      font-weight: 400;
      font-size: .8419rem;
      color: #fff;

      line-height: 1.6236rem;
      text-align: center;
      font-style: normal;
    }

    .expand_div {
      position: absolute;
      height: 4.3897rem;
      right: 3.8485rem;
      bottom: 0;
      box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.16);
      border-radius: 6px 6px 6px 6px;
      background-color: #fff;
      display: flex;
      align-items: center;

      .expand_div_item {
        margin: 0 1.2026rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        opacity: 0;
        transition: opacity .5s ease-in-out;

        .expand_div_item_img {
          height: 1.5634rem;
          width: 1.5634rem;
          margin-bottom: .4811rem;
        }

        .expand_div_item_text {
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: .8419rem;
          color: #666666;
          line-height: 1.1425rem;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
      }

      .expand_div_item_show {
        animation: itemShow 1.2s forwards;
      }

      .expand_div_item_hidden {
        opacity: 0;
      }
    }

    // 关闭批量处理
    .expand_close {
      display: none;
    }

    // 打开批量处理
    .expand_open {
      animation: expandopen .3s ease-out forwards;
      will-change: width;
    }
  }
}
</style>
